import React, { useState } from "react"
import { useWindowWidth } from "@react-hook/window-size"

import sample from "lodash.sample"

/* Import Local Components */
import Description from "../description/_description"

/* Import Local Style(s) */
import "./audio.css"

const Audio = ({ src, filtered, project, size, audioCredit }) => {
  const windowWidth = useWindowWidth()
  const [marginTop] = useState(
    windowWidth > 768
      ? sample(["0", "4vh", "16vh", "32vh"])
      : sample(["0", "6vh", "9vh", "14vh"])
  )

  return (
    <div
      className={`trace trace-audio ${filtered ? "filtered" : ""} ${size}`}
      style={{ marginTop }}
    >
      <audio src={src} controls>
        <track kind="captions" />
      </audio>
      <Description project={project} credit={audioCredit} />
    </div>
  )
}

export default Audio
